import React from 'react';
import { IConfigComponent } from '@ts/ui-models';
import _ from 'lodash';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import {
  IDataGridConfig,
  TInheritedProps,
  generateGlobalColumns,
  generateDateColumn,
  generateEntityColumn,
  generateMultiEntityColumn,
} from '@ts/storybook';

import moment from 'moment';
import { CElement, CTask, CUser } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'tasks',
  aclId: 'taTask',
  entity: 'task',
  fetchURL: '/api/tasks/v2',
  crudURL: '/api/task',
  mainClass: CTask,
};

interface TasksProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  title?: string;
}

const Tasks: React.FC<TasksProps> = props => {
  const { title, configComponent = defaultConfigComponent, inheritedProps } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  //#region Functions
  const getColumns = (): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name('Description / ID', CTask),
      generateDateColumn(
        { field: 'dueTimestamp', headerName: 'Due date' },
        {
          field: 'dueTimestamp',
        }
      ),
      generateEntityColumn(
        { field: 'taskType', headerName: 'Task type' },
        { field: 'taskType', mainClass: CTask },
        { inheritedProps }
      ),
      generateEntityColumn({ field: 'assignee' }, { field: 'responsibleUser', mainClass: CUser }, { inheritedProps }),
      /* {
        field: 'assignee',
        headerName: 'Assignee',
        filterable: false,
        valueGetter: (value, row, column) => {
          const tClass = new CTask(row);
          return tClass.getAssignee;
        },
        renderCell: (params: GridRenderCellParams) => {
          const tClass = new CTask(params.row);
          if (!tClass.responsibleUserId) return;
          return (
            <EntityCell
              entity={'user'}
              primaryLabel={tClass.getAssignee}
              secondaryLabel={tClass.responsibleUserId}
              isEntitySelector={props.inheritedProps?.isEntitySelector}
            />
          );
        },
      }, */
      generateMultiEntityColumn(
        { field: 'xTaskItems', headerName: 'Related items' },
        { field: 'xTaskItems', tEntity: 'item', mainClass: CElement },
        { inheritedProps }
      ),
      {
        field: 'daysToDue',
        type: 'string',
        headerName: 'Days to due',
        filterable: false,
        valueGetter: (value, row, column) => {
          const date = moment(row.dueTimestamp).fromNow();
          return date;
        },
      },
      {
        field: 'timeToWarning',
        type: 'string',
        headerName: 'Time to warning',
        filterable: false,
        valueGetter: (value, row, column) => {
          let days, due;
          days = row.warningBefore;
          if (!days) {
            return;
          }
          due = row.dueTimestamp;
          return moment(due).subtract(days, row.warningBeforeUnits).fromNow();
        },
      },
    ];
  };
  //#endregion

  return (
    <WrapperDataGrid
      title={title}
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns()}
      //extraActions={actions}
      //From grandpa
      inheritedProps={inheritedProps}
      enabledFilters
    />
  );
};

export default Tasks;
